import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CustomAdminTab from "./components/CustomAdminTab";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
}));

export default function AdminTab(props) {
  const classes = useStyles();

  return (
    <div className="m-sm-10">
        <CustomAdminTab />
      </div>
  );
}
